export const isObscuredCNPJ = (value: string) =>
  value
    .toString()
    .match(/[0-9*]/g)
    ?.join('').length === 14;
